export function getRequestIdFromError (error: unknown) {
  if (
    error &&
    typeof error === 'object' &&
    'requestId' in error &&
    typeof error.requestId === 'string'
  ) {
    return error.requestId
  }

  return undefined
}
